module.exports = __webpack_public_path__ + "media/images/element/06-e73ad773bc72c8e919e5f4647bcbf7c6.svg";